import { render } from "./SkyTable.vue?vue&type=template&id=1aa2e728"
import script from "./SkyTable.vue?vue&type=script&lang=js"
export * from "./SkyTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__